<template>
  <div class="create-new-card" @click="$emit('click')">
    <div class="create-icon-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M24 13.7143H13.7143V24H10.2857V13.7143H0V10.2857H10.2857V0H13.7143V10.2857H24V13.7143Z" fill="currentColor"/>
      </svg>
    </div>
    <p class="create-text">{{ textContent }}</p>
  </div>
</template>

<script>
export default {
  name: 'CreateNewCard',
  props: {
    textContent: {
      type: String,
      required: true
    }
  },
  emits: ['click']
};
</script>

<style scoped>
.create-new-card {
  background: #F2F2F2;
  border: 1px dashed #C4C4C4;
  border-radius: 10px;
  padding: 24px;
  height: 144px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  box-sizing: border-box;
}

.create-new-card:hover {
  background: #F9FBFD;
  border-width: 2px;
}

.create-icon-wrapper {
  width: 56px;
  height: 56px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F9FBFD;
  border-radius: 5px;
  flex-shrink: 0;
  color: #374957;
  box-sizing: border-box;
}

.create-new-card:hover .create-icon-wrapper {
  background: #004879;
  color: #FFFFFF;
}

.create-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  margin: 0;
}
</style>
